import { render } from "./VersionLog.vue?vue&type=template&id=23ad3bfe&scoped=true"
import script from "./VersionLog.vue?vue&type=script&lang=js"
export * from "./VersionLog.vue?vue&type=script&lang=js"

import "./VersionLog.vue?vue&type=style&index=0&id=23ad3bfe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ad3bfe"]])

export default __exports__